module.exports = __webpack_public_path__ + "img/1.b5b52a56.jpg";